export default "<p>outsource-calendar works!</p>\n"